import Vue from 'vue';
import Notifications from 'vue-notification';

Vue.use(Notifications);

Vue.toaster = Vue.prototype.toaster = {
  success: (msg, duration) => {
    toasterFunc('success', msg, duration);
  },
  error: (msg, duration) => {
    toasterFunc('error', msg, duration);
  },
  notify: (title, msg, duration) => {
    notifyFunc(title, msg, duration);
  },
};

const toasterFunc = (type, msg, duration = 8000) => {
  Vue.notify({
    type: type,
    title: msg,
    duration: duration,
  });
};

const notifyFunc = (title, msg, duration = 8000) => {
  Vue.notify({
    group: 'real-time',
    title: title,
    text: msg.message,
    data: {
      url: msg.url,
      id: msg.id,
    },
    duration: duration,
    closeOnClick: true,
  });
};
